import { render } from "./Widget3.vue?vue&type=template&id=3b655a06"
import script from "./Widget3.vue?vue&type=script&lang=js"
export * from "./Widget3.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__